import React from "react";
import DreamJobCallout from "@components/applications/dream_job_callout";

const ChooseDreamJob: React.FC = () => {
  return (
    <div className="w-[304px] min-w-[304px] max-w-[304px] min-h-[200px] h-full">
      <DreamJobCallout redirectTo="/dashboard" className="h-full" />
    </div>
  );
};

export default ChooseDreamJob;
